var map = {
	"./L0.jpg": "48d4",
	"./L1.jpg": "be6d",
	"./L2.jpg": "9971",
	"./L3.jpg": "0c21",
	"./L4.jpg": "fd2e",
	"./L5.jpg": "b5cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "774a";